import GetAccess from './GetAccess'

export default GetAccess
